import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import EachTrigger from "./EachTrigger";
import {
  setRequiredError,
  setTriggerItem,
  setTriggerItemValue,
  setTriggerDefineFilter,
  resetTriggerActions,
  setSelectedTriggerActionId,
} from "../../actions/triggerAction";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import TextField from "@material-ui/core/TextField";
import { Info } from "@material-ui/icons";
import Styles from "../new-style.module.css";
import Utils from "../../../addContact/Utils";
import {
  AGENCY_BUSINESS_TYPE,
  ANNIVERSARY_REMAINDER,
  BIRTHDAY_REMAINDER,
  PERMISSION_LEVELS,
  PERMISSION_MODULES,
  PRIVACY_LEVEL,
  TRIGGER_TYPES,
} from "../../../../helpers/CoreConstant";
import { iconList } from "../../IconList";
import CustomMenuPype from "../../../GlobalContactDetailsForDeal/common/custom-menu/CustomMenuPype";
import IncomingCallFilter from "../incomingCall/IncomingCallFilter";
import "../trigger-settings.css";
import { DropdownHelper } from "../DropdownHelper";

const mapStateToProps = (state) => {
  return {
    loading: state.triggerSettingReducer.loading,
    triggerRule: state.triggerSettingReducer.triggerRule,
    allTriggerItem: state.triggerSettingReducer.allTriggerItem,
    allCampaign: state.triggerSettingReducer.allCampaign,
    allCalendar: state.triggerSettingReducer.allCalendar,
    allPipeline: state.triggerSettingReducer.allPipeline,
    allStage: state.triggerSettingReducer.allStage,
    allTag: state.triggerSettingReducer.allTag,
    allList: state.triggerSettingReducer.allList,
    allForm: state.triggerSettingReducer.allForm,
    data: state.triggerSettingReducer.data,
    allVirtualNumber: state.triggerSettingReducer.allVirtualNumber,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    setTriggerItem: (triggerActionId) =>
      dispatch(setTriggerItem(triggerActionId)),
    setTriggerItemValue: (param) => dispatch(setTriggerItemValue(param)),
    setRequiredError: (param) => dispatch(setRequiredError(param)),
    changeDefineFilter: (param) => dispatch(setTriggerDefineFilter(param)),
    resetTriggerActions: (param) => dispatch(resetTriggerActions(param)),
    setSelectedTriggerActionId: (param) =>
      dispatch(setSelectedTriggerActionId(param)),
  };
}

const triggerWithVoiceMail = 2;
const triggerWithOutVoiceMail = 1;

const MISSED_CALL_FILTER_OPTIONS = [
  {
    label: "Run trigger for missed calls and voicemails",
    value: triggerWithVoiceMail,
  },
  { label: "Run trigger when I miss a call", value: triggerWithOutVoiceMail },
];

const VIRTUAL_NUMBER_ALL = [{ label: "All virtual numbers", value: "-1" }];

const VIRTUAL_NUMBER_DEFAULT = [
  { label: "{{user_default_number}}", value: "{{user_default_number}}" },
];

const FORM_TYPE = {
  OLD: 1,
  NEW: 2,
};

const Trigger = (props) => {
  const { pipeline_id, stage_id } = props.modalData || {};
  const defaultPipelineOptions = props.allPipeline.map((p) => ({
    label: p.title,
    value: p.id,
  }));
  const defaultStageOptions = props.allStage
    .filter((s) => s.pipeline_id === pipeline_id)
    .map((s) => ({
      label: s.stage,
      value: s.id,
    }));

  const selectedPipelineOption =
    defaultPipelineOptions.find((o) => o.value === pipeline_id) || null;
  const selectedStageOption =
    defaultStageOptions.find((o) => o.value === stage_id) || null;

  const [state, setState] = useState({
    show: false,
    showSimpleFilter: Boolean(pipeline_id && stage_id),
    selected_trigger_id:
      props?.modalData?.from === "deals" ? TRIGGER_TYPES.STAGE_CHANGE : 0,
    selected_trigger:
      props?.modalData?.from === "deals"
        ? {
            id: TRIGGER_TYPES.STAGE_CHANGE,
            name: "Pipeline Stage Changed",
            key_index: TRIGGER_TYPES.STAGE_CHANGE,
            value: '[["In Pipeline"]]',
            description: "The customer/lead pipeline stage updated",
            status: 1,
            created_at: "2020-09-10 14:00:02",
            updated_at: "2020-09-10 14:00:02",
          }
        : {},
    selected_trigger_item_value_length: 1,
    eachTriggerRow: [],
    trigger_value_selected: [],
    trigger_sub_value: [],
    text_reminder_timing_generator: true,
    textReminderChecked: 1,
    selectedValuesToTrigger: [],
    remainingValuesToTrigger: [],
    showFiltering: Boolean(pipeline_id && stage_id),

    added_campaign_option: null,
    selected_campaign_to_take_action_in_campaign_added: null,
    defaultCampaignOptions: [],

    customer_booked_appointment_option: null,
    defaultCalendarOptions: [],
    selected_calendar_to_take_action: null,
    selected_appointment_mark_as_to_take_action: null,

    added_tag_option: null,
    defaultTagEventOptions: [],
    defaultTagOptions: [],
    selected_tag_to_take_action: null,

    task_remainder_option: null,
    defaultTaskRemainderEventOptions: [],
    task_remainder_day: null,

    change_stage_option: 0,
    selected_pipeline_to_take_action: selectedPipelineOption,
    selected_stage_to_take_action: selectedStageOption,
    defaultPipelineOptions,
    defaultStageOptions,

    deal_pipeline_id: null,
    deal_status: null,
    defaultDealStatusEventOptions: [],

    added_list_option: null,
    defaultListEventOptions: [],
    defaultListOptions: [],
    selected_list_to_take_action: null,

    added_form_option: null,
    defaultFormEventOptions: [],
    defaultFormOptions: [],
    selected_form_to_take_action: null,

    //incoming call
    added_virtual_number_option: null,
    selected_virtual_number_to_take_action: null,
    defaultVirtualNumbers: [],

    //Missed call
    missed_call_option: null,
    selected_missed_call_filter: null,

    /* for twilio error code */
    triggerValue: null,

    firstRender: true,
  });

  const { triggerRule } = props;

  useEffect(() => {

    if (!!triggerRule.rule_trigger_action) {
      const trigger_item_id =
        triggerRule.rule_trigger_action.user_trigger_item_id;
      const trigger_item_value =
        triggerRule.rule_trigger_action.user_trigger_item_value;
      let data = getTriggerById(trigger_item_id, props.allTriggerItem);
      changeValue(trigger_item_id, data[0]);

      if (trigger_item_value) {
        if (trigger_item_id === TRIGGER_TYPES.ADDED_CAMPAIGN) {
          //If trigger comes from snapshot
          if (trigger_item_value.campaign_id === null) {
            setState((prevState) => ({
              ...prevState,
              selected_campaign_to_take_action_in_campaign_added: {
                value: null,
              },
              showSimpleFilter: true,
            }));
            setTriggerItemValue();
          } else {
            let campaignData = getTriggerById(
              trigger_item_value.campaign_id,
              props.allCampaign
            );
            if (campaignData[0]) {
              setState((prevState) => ({
                ...prevState,
                selected_campaign_to_take_action_in_campaign_added: {
                  label: campaignData[0].title,
                  value: trigger_item_value.campaign_id,
                },
                added_campaign_option: trigger_item_value.option,
                showSimpleFilter: true,
              }));

              setTriggerItemValue();
            }
          }
        } else if (
          trigger_item_id === TRIGGER_TYPES.CUSTOMER_BOOKED_APPOINTMENT
        ) {
          let calendarData = getTriggerById(
            trigger_item_value.calendar_id,
            props.allCalendar
          );
          if (calendarData[0] || trigger_item_value.calendar_id === "") {
            setState((prevState) => ({
              ...prevState,
              selected_calendar_to_take_action: calendarData[0]
                ? {
                    label: calendarData[0].title,
                    value: trigger_item_value.calendar_id,
                  }
                : null,
              customer_booked_appointment_option: trigger_item_value.option,
              showSimpleFilter: true,
            }));

            setTriggerItemValue();
          }
        } else if (trigger_item_id === TRIGGER_TYPES.ADDED_TAG) {
          let tagData = getTriggerById(trigger_item_value.tag_id, props.allTag);
          if (tagData[0] || trigger_item_value.tag_id === "") {
            let optionTag = "Tag Added";
            if (trigger_item_value.option == 1) {
              optionTag = "Tag Removed";
            }
            setState((prevState) => ({
              ...prevState,
              selected_tag_to_take_action: tagData[0]
                ? { label: tagData[0].name, value: trigger_item_value.tag_id }
                : null,
              added_tag_option: {
                label: optionTag,
                value: trigger_item_value.option,
              },
              showSimpleFilter: true,
            }));

            setTriggerItemValue();
          }
        } else if (trigger_item_id === TRIGGER_TYPES.FORM_SUBMISSION) {
          /*else if (trigger_item_id === TRIGGER_TYPES.CONTACT_LIST) {
                        let listData = getTriggerById(trigger_item_value.contact_list_id, props.allList);
                        if(listData[0]){
                            let optionList = "Removed from Contact List";
                            if(trigger_item_value.option == 1){
                                optionList = "Added in Contact List";
                            }
                            setState({
                                selected_list_to_take_action: {
                                    label: listData[0].title,
                                    value: trigger_item_value.contact_list_id
                                },
                                added_list_option: {
                                    /!*label: JSON.parse(data[0].value)[trigger_item_value.option],*!/
                                    label: optionList,
                                    value: trigger_item_value.option
                                },
                                showSimpleFilter: true

                            },()=>setTriggerItemValue())
                        }
                    }*/
          let formData = props.allForm.filter((trigger) =>
            trigger_item_value.type
              ? trigger.id == trigger_item_value.form_id &&
                trigger.type == trigger_item_value.type
              : trigger.id == trigger_item_value.form_id
          );
          if (formData[0] || trigger_item_value.form_id === "") {
            let optionForm = "Form Submit";
            if (trigger_item_value.option == 1) {
              optionForm = "Resubmit form";
            }
            setState((prevState) => ({
              ...prevState,
              selected_form_to_take_action: formData[0]
                ? {
                    label: formData[0].title,
                    value: trigger_item_value.form_id,
                    type: formData[0].type ? formData[0].type : FORM_TYPE.OLD,
                  }
                : null,
              added_form_option: {
                label: optionForm,
                value: trigger_item_value.option,
              },
              showSimpleFilter: true,
            }));
            setTriggerItemValue();
          }
        } else if (trigger_item_id === TRIGGER_TYPES.DEAL_STATUS_CHANGE) {
          let optionTag = "Deal Lost";
          if (trigger_item_value.option == 1) {
            optionTag = "Deal Won";
          }
          let PipelineData = getTriggerById(
            trigger_item_value.pipeline_id,
            props.allPipeline
          );
          if (PipelineData[0] || trigger_item_value.pipeline_id === "") {
            setState((prevState) => ({
              ...prevState,
              deal_pipeline_id: PipelineData[0]
                ? {
                    label: PipelineData[0].title,
                    value: trigger_item_value.pipeline_id,
                  }
                : null,
            }));

            setTriggerItemValue();
          }
          setState((prevState) => ({
            ...prevState,
            deal_status: {
              label: optionTag,
              value: trigger_item_value.option,
            },
            showSimpleFilter: true,
          }));
          setTriggerItemValue();
        }

        //! incoming call
        else if (
          trigger_item_id === TRIGGER_TYPES.INCOMING_CALL ||
          trigger_item_id === TRIGGER_TYPES.OUTGOING_CALL
        ) {
          let virtualNumbers = getTriggerById(
            trigger_item_value.virtual_number_id,
            props.allVirtualNumber
          );
          if (
            virtualNumbers[0] ||
            trigger_item_value.virtual_number_id === "" ||
            trigger_item_value.virtual_number_id ===
              VIRTUAL_NUMBER_DEFAULT[0].value
          ) {
            if (
              trigger_item_value.virtual_number_id ===
              VIRTUAL_NUMBER_DEFAULT[0].value
            ) {
              setState((prevState) => ({
                ...prevState,
                selected_virtual_number_to_take_action:
                  VIRTUAL_NUMBER_DEFAULT[0],
                added_virtual_number_option: trigger_item_value.option,
                showSimpleFilter: true,
              }));
              setTriggerItemValue();
            } else {
              setState((prevState) => ({
                ...prevState,
                selected_virtual_number_to_take_action: virtualNumbers[0]
                  ? {
                      label: virtualNumbers[0].label,
                      value: virtualNumbers[0].id,
                    }
                  : null,
                added_virtual_number_option: trigger_item_value.option,
                showSimpleFilter: true,
              }));
              setTriggerItemValue();
            }
          }
        } else if (trigger_item_id === TRIGGER_TYPES.TASK_REMAINDER) {
          let content = "Before No of Days";
          if (trigger_item_value.option == 1) {
            content = "After No of Days";
          }
          setState((prevState) => ({
            ...prevState,
            task_remainder_option: {
              label: content,
              value: trigger_item_value.option,
            },
            task_remainder_day: trigger_item_value.number_of_day,
            showSimpleFilter: true,
          }));
          setTriggerItemValue();
        } else if (
          trigger_item_id === TRIGGER_TYPES.CONTACT_REPLIED ||
          trigger_item_id === TRIGGER_TYPES.ANNIVERSARY_REMAINDER ||
          trigger_item_id === TRIGGER_TYPES.BIRTHDAY_REMAINDER ||
          trigger_item_id === TRIGGER_TYPES.APPOINTMENT ||
          trigger_item_id === TRIGGER_TYPES.STALE_OPPORTUNITY
        ) {
          setRemainingValueAtFirst(
            trigger_item_value,
            JSON.parse(data[0].value)
          );
          setTriggerValue(trigger_item_value, trigger_item_id);
        } else if (trigger_item_id === TRIGGER_TYPES.STAGE_CHANGE) {
          let PipelineData = getTriggerById(
            trigger_item_value.pipeline_id,
            props.allPipeline
          );
          let StageData = getTriggerById(
            trigger_item_value.stage_id,
            props.allStage
          );
          if (PipelineData[0] || trigger_item_value.pipeline_id === "") {
            setState((prevState) => ({
              ...prevState,
              selected_pipeline_to_take_action: PipelineData[0]
                ? {
                    label: PipelineData[0].title,
                    value: trigger_item_value.pipeline_id,
                  }
                : null,
              change_stage_option: trigger_item_value.option,
              showSimpleFilter: true,
            }));
            setTriggerItemValue();
          }
          if (StageData[0]) {
            setState((prevState) => ({
              ...prevState,
              selected_stage_to_take_action: {
                label: StageData[0].stage,
                value: trigger_item_value.stage_id,
              },
            }));
            setTriggerItemValue();
          }
          getDefaultOptionForStage(trigger_item_value.pipeline_id);
        } else if (
          trigger_item_id === TRIGGER_TYPES.APPOINTMENT_STATUS_CHANGE
        ) {
          setState((prevState) => ({
            ...prevState,
            selected_appointment_mark_as_to_take_action: {
              label: "Done",
              value: 0,
            },
            showSimpleFilter: true,
          }));
          setTriggerItemValue();
        } else if (trigger_item_id === TRIGGER_TYPES.CREATE_ACTIVITY) {
          let remainingValueSet = [];

          if (trigger_item_value && trigger_item_value.option.length > 0) {
            let val = [...JSON.parse(data[0].value)];
            let reomveIndex = [];
            for (let i = 0; i < trigger_item_value.option.length; i++) {
              if (i === 0) {
                remainingValueSet[i] = val;
              } else {
                for (let j in val) {
                  if (val[j][trigger_item_value.option[i - 1]]) {
                    reomveIndex.push(parseInt(j));
                    break;
                  }
                }

                remainingValueSet[i] = val.filter(function (value, index) {
                  return reomveIndex.indexOf(index) === -1;
                });
              }
            }
            setState((prevState) => ({
              ...prevState,
              trigger_value_selected: trigger_item_value.option,
              showFiltering: true,
              selected_value: data[0],
              eachTriggerRow: trigger_item_value.option,
              remainingValuesToTrigger: remainingValueSet,
            }));
            setTriggerItemValue();
          }
        } else if (trigger_item_id === TRIGGER_TYPES.MISSED_CALL) {
          let missedCallData = MISSED_CALL_FILTER_OPTIONS.filter(
            (filter) => filter.value == trigger_item_value.subOption
          );
          if (missedCallData[0]) {
            setState((prevState) => ({
              ...prevState,
              selected_missed_call_filter: {
                label: missedCallData[0].label,
                value: trigger_item_value.subOption,
              },
              missed_call_option: trigger_item_value.option,
              showSimpleFilter: true,
            }));

            setTriggerItemValue();
          }

          let virtualNumbers = props.allVirtualNumber.filter(
            (filter) => filter.label == trigger_item_value.virtualNumber
          );
          let virtualNumber = null;
          if (virtualNumbers[0]) {
            virtualNumber = {
              label: virtualNumbers[0].label,
              value: virtualNumbers[0].id,
            };
          } else if (trigger_item_value.virtualNumber === "-1") {
            virtualNumber = {
              label: VIRTUAL_NUMBER_ALL[0].label,
              value: VIRTUAL_NUMBER_ALL[0].value,
            };
          } else if (
            trigger_item_value.virtualNumber === VIRTUAL_NUMBER_DEFAULT[0].value
          ) {
            virtualNumber = {
              label: VIRTUAL_NUMBER_DEFAULT[0].label,
              value: VIRTUAL_NUMBER_DEFAULT[0].value,
            };
          }

          setState((prevState) => ({
            ...prevState,
            selected_virtual_number_to_take_action: virtualNumber,
          }));
          setTriggerItemValue();
        }
      }
    }else if (pipeline_id && stage_id) {
      props.setTriggerItem(TRIGGER_TYPES.STAGE_CHANGE);
      props.changeDefineFilter(TRIGGER_TYPES.STAGE_CHANGE);
      props.setTriggerItemValue({
        option: 0,
        pipeline_id,
        stage_id,
      });
    }
  }, []);

  useEffect(() => {
    setTriggerItemValue();
  }, [
        state.selected_campaign_to_take_action_in_campaign_added, 
        state.trigger_sub_value, 
        state.selected_appointment_mark_as_to_take_action,
        state.selected_tag_to_take_action,
        state.added_tag_option,
        state.selected_calendar_to_take_action,
        state.deal_pipeline_id,
        state.deal_status,
        state.selected_form_to_take_action,
        state.selected_virtual_number_to_take_action,
        state.selected_pipeline_to_take_action,
        state.selected_stage_to_take_action,
        state.task_remainder_option,
        state.task_remainder_day,
        state.trigger_value_selected,
        state.added_form_option,
        state.selected_missed_call_filter,
    ])
  

  const hasGlobalFeaturePermission = Utils.getAccountData("agencyBusinessType") === AGENCY_BUSINESS_TYPE.INSURANCE || Utils.getAccountData("hasGlobalFeature");
  const canUserManageGlobalItem = window.hasPermission(
    PERMISSION_MODULES.MANAGE_GLOBAL_ITEMS,
    PERMISSION_LEVELS.WRITE
  );

  const isTriggerPrivate =
    props.triggerRule.privacy_level === PRIVACY_LEVEL.PRIVACY_LEVEL_PRIVATE;
  const isUserTriggerOwner =
    props.triggerRule.user_id === Utils.getAccountData("userId");
  const hasPermission =
    (hasGlobalFeaturePermission &&
      ((!isTriggerPrivate && canUserManageGlobalItem) ||
        (isTriggerPrivate && isUserTriggerOwner))) ||
    !hasGlobalFeaturePermission;

  const addSimpleFilter = () => {
    setState((prevState) => ({
      ...prevState,
      showSimpleFilter: true,
    }));
    props.setRequiredError(true);
  };

  const removeSimpleFilter = () => {
    setState((prevState) => ({
      ...prevState,
      showSimpleFilter: false,
      selected_campaign_to_take_action_in_campaign_added: null,
      selected_appointment_mark_as_to_take_action: null,
      selected_tag_to_take_action: null,
      selected_form_to_take_action: null,
      deal_pipeline_id: null,
      selected_calendar_to_take_action: null,
      selected_virtual_number_to_take_action: null,
      selected_stage_to_take_action: null,
      selected_pipeline_to_take_action: null,
    }));
    props.setTriggerItemValue([]);
    props.setRequiredError(false);
  };

  const onValueChange = (index, value, triggerType) => {
    let triggerValueSet = [...state.trigger_value_selected];
    if (triggerType && triggerType === TRIGGER_TYPES.CREATE_ACTIVITY) {
      value = parseInt(value);
      if (triggerValueSet.includes(value)) {
        window.showNotification("ERROR", "This filter already selected");
      } else {
        triggerValueSet[index] = value;
        setState((prevState) => ({
          ...prevState,
          trigger_value_selected: triggerValueSet,
        }));
        setTriggerItemValue();
      }
    } else {
      triggerValueSet[index] = value;
      setState((prevState) => ({
        ...prevState,
        trigger_value_selected: triggerValueSet,
      }));

      setTriggerItemValue();
    }
  };

  const onUnitChange = (index, value, reminderType) => {
    let triggerSubValueSet = [...state.trigger_sub_value];
    triggerSubValueSet[index] = value;

    setState((prevState) => ({
      ...prevState,
      trigger_sub_value: triggerSubValueSet,
    }));
    
  };

  const setSelectedTagOption = (index, selected_tag_option) => {
    let triggerSubValueSet = [...state.trigger_sub_value];
    triggerSubValueSet[index] = selected_tag_option;
    setState((prevState) => ({
      ...prevState,
      trigger_sub_value: triggerSubValueSet,
    }));
    setTriggerItemValue();
  };

  const removeFilter = (index, trigger) => {
    if (trigger == state.selected_trigger_id) {
      var eachTriggerRow = [...state.eachTriggerRow];
      let triggerValueSet = [...state.trigger_value_selected];
      let triggerSubValueSet = [...state.trigger_sub_value];
      let remainingValuesToTrigger = [...state.remainingValuesToTrigger];

      let length = eachTriggerRow.length;
      if (length == 1) {
        removeSimpleFilter();
        setState((prevState) => ({
          ...prevState,
          showFiltering: false,
        }));
      }
      if (index !== -1) {
        eachTriggerRow.splice(index, 1);
        triggerValueSet.splice(index, 1);
        triggerSubValueSet.splice(index, 1);
        remainingValuesToTrigger.splice(index, 1);
        setState((prevState) => ({
          ...prevState,
          eachTriggerRow: eachTriggerRow,
          trigger_value_selected: triggerValueSet,
          trigger_sub_value: triggerSubValueSet,
          remainingValuesToTrigger: remainingValuesToTrigger,
        }));
        setTriggerItemValue();
        remainingValuesToTriggers(length - 1);
      }
    }
  };

  const addNewFilter = () => {
    let eachTriggerRow = state.eachTriggerRow;
    let rowIndex = eachTriggerRow.length;
    remainingValuesToTriggers(rowIndex);

    setState((prevState) => ({
      ...prevState,
      eachTriggerRow: prevState.eachTriggerRow.concat(
        <EachTrigger
          remover={removeFilter}
          key={rowIndex}
          RowIndex={rowIndex}
        />
      ),
      showFiltering: true,
    }));
    addSimpleFilter();
  };
  const getEachTrigger = (allTriggerItem) => {
    var data = [];
    if (allTriggerItem.length > 0) {
      data = allTriggerItem.map((data, index) => {
        return (
          <MenuItem
            className="dropdownhelper-menuitem-class color__trigger_select"
            onClick={() => {
              changeValue(data.key_index, data);
            }}
            value={data.key_index}
            primaryText={data.name}
          >
            <div className={"flex__column"}>
              {data.name}
              <small>{data.description}</small>
            </div>
          </MenuItem>
        );
      });
    }
    return data;
  };

  const show = (e) => {
    e.preventDefault();
    setState((prevState) => ({
      show: !prevState.show,
    }));
  };

  const hide = () => {
    setState((prevState) => ({
      show: false,
      ...prevState,
    }));
  };

  const getTriggerById = (id, triggers) => {
    return triggers.filter((trigger) => trigger.id == id);
  };

  const remainingValuesToTriggers = (rowIndex) => {
    let remainingValuesToTrigger = [];
    let remainingValueSet = [...state.remainingValuesToTrigger];
    if (state.trigger_value_selected.length > 0) {
      const values = JSON.parse(state.selected_trigger.value);
      remainingValuesToTrigger = values.filter((value) => {
        if (state.selected_trigger_id == TRIGGER_TYPES.CREATE_ACTIVITY) {
          if (
            !state.trigger_value_selected.includes(parseInt(Object.keys(value)))
          ) {
            return value;
          }
        } else if (
          !state.trigger_value_selected.includes(Object.keys(value).toString())
        ) {
          if (rowIndex > 0) {
            if (
              state.selected_trigger_id ==
                TRIGGER_TYPES.ANNIVERSARY_REMAINDER &&
              Object.keys(value) == ANNIVERSARY_REMAINDER.BEFORE_NO_OF_DAYS
            ) {
              if (
                !state.trigger_value_selected.includes(
                  ANNIVERSARY_REMAINDER.AFTER_NO_OF_DAYS.toString()
                ) &&
                !state.trigger_value_selected.includes(
                  ANNIVERSARY_REMAINDER.CURRENT_DAY.toString()
                )
              ) {
                return value;
              }
            } else if (
              state.selected_trigger_id ==
                TRIGGER_TYPES.ANNIVERSARY_REMAINDER &&
              Object.keys(value) == ANNIVERSARY_REMAINDER.AFTER_NO_OF_DAYS
            ) {
              if (
                !state.trigger_value_selected.includes(
                  ANNIVERSARY_REMAINDER.BEFORE_NO_OF_DAYS.toString()
                ) &&
                !state.trigger_value_selected.includes(
                  ANNIVERSARY_REMAINDER.CURRENT_DAY.toString()
                )
              ) {
                return value;
              }
            } else if (
              state.selected_trigger_id ==
                TRIGGER_TYPES.ANNIVERSARY_REMAINDER &&
              Object.keys(value) == ANNIVERSARY_REMAINDER.CURRENT_DAY
            ) {
              if (
                !state.trigger_value_selected.includes(
                  ANNIVERSARY_REMAINDER.BEFORE_NO_OF_DAYS.toString()
                ) &&
                !state.trigger_value_selected.includes(
                  ANNIVERSARY_REMAINDER.AFTER_NO_OF_DAYS.toString()
                )
              ) {
                return value;
              }
            } else if (
              state.selected_trigger_id == TRIGGER_TYPES.BIRTHDAY_REMAINDER &&
              Object.keys(value) == BIRTHDAY_REMAINDER.BEFORE_NO_OF_DAYS
            ) {
              if (
                !state.trigger_value_selected.includes(
                  BIRTHDAY_REMAINDER.AFTER_NO_OF_DAYS.toString()
                ) &&
                !state.trigger_value_selected.includes(
                  BIRTHDAY_REMAINDER.CURRENT_DAY.toString()
                )
              ) {
                return value;
              }
            } else if (
              state.selected_trigger_id == TRIGGER_TYPES.BIRTHDAY_REMAINDER &&
              Object.keys(value) == BIRTHDAY_REMAINDER.AFTER_NO_OF_DAYS
            ) {
              if (
                !state.trigger_value_selected.includes(
                  BIRTHDAY_REMAINDER.BEFORE_NO_OF_DAYS.toString()
                ) &&
                !state.trigger_value_selected.includes(
                  BIRTHDAY_REMAINDER.CURRENT_DAY.toString()
                )
              ) {
                return value;
              }
            } else if (
              state.selected_trigger_id == TRIGGER_TYPES.BIRTHDAY_REMAINDER &&
              Object.keys(value) == BIRTHDAY_REMAINDER.CURRENT_DAY
            ) {
              if (
                !state.trigger_value_selected.includes(
                  BIRTHDAY_REMAINDER.BEFORE_NO_OF_DAYS.toString()
                ) &&
                !state.trigger_value_selected.includes(
                  BIRTHDAY_REMAINDER.AFTER_NO_OF_DAYS.toString()
                )
              ) {
                return value;
              }
            } else {
              return value;
            }
          } else {
            return value;
          }
        }
      });

      remainingValueSet[rowIndex] = remainingValuesToTrigger;
      setState((prevState) => ({
        ...prevState,
        remainingValuesToTrigger: remainingValueSet,
      }));
    } else {
      remainingValueSet[rowIndex] = JSON.parse(state.selected_trigger.value);
      setState((prevState) => ({
        ...prevState,
        remainingValuesToTrigger: remainingValueSet,
      }));
    }
  };

  const actionAddToCampaign = (selectedOption) => {
    setState((prevState) => ({
      ...prevState,
      selected_campaign_to_take_action_in_campaign_added: selectedOption,
    }));
  };

  const actionChangeMissedCall = (selectedOption) => {
    setState((prevState) => ({
      ...prevState,
      selected_missed_call_filter: selectedOption,
    }));
  };

  const actionToChangeAddedCampaignOption = (selectedOption) => {};

  const actionToChangeMissedCallOption = (selectedOption) => {};

  const actionToChangeAddedTagOption = (selectedOption) => {
    setState((prevState) => ({
        ...prevState,
        added_tag_option: selectedOption,
    }));
  };

  const actionToChangeAddedListOption = (selectedOption) => {
    setState((prevState) => ({
      added_list_option: selectedOption,
      ...prevState,
    }));
    setTriggerItemValue();
  };

  const actionToChangeAddedFormOption = (selectedOption) => {
    setState((prevState) => ({
      ...prevState,
      added_form_option: selectedOption,
    }));
    // setTriggerItemValue();
  };

  const actionToChangeDealStatusOption = (selectedOption) => {
    setState((prevState) => ({
      ...prevState,
      deal_status: selectedOption,
    }));

    setTriggerItemValue();
  };

  const actionToChangeTaskRemainderOption = (selectedOption) => {
    setState((prevState) => ({
      ...prevState,
      task_remainder_option: selectedOption,
    }));

    // setTriggerItemValue();
  };

  const getDefaultOptionForCampaign = () => {
    let allOptions = [];
    if (props.allCampaign.length > 0) {
      const filteredCampaigns =
        hasGlobalFeaturePermission &&
        props.triggerRule.privacy_level &&
        props.triggerRule.privacy_level === PRIVACY_LEVEL.PRIVACY_LEVEL_GLOBAL
          ? props.allCampaign.filter(
              (item) => item.privacyLevel === PRIVACY_LEVEL.PRIVACY_LEVEL_GLOBAL
            )
          : props.allCampaign;

      allOptions = filteredCampaigns.map((item) => ({
        value: item.id,
        label: item.title,
      }));
    }
    setState((prevState) => ({
      ...prevState,
      defaultCampaignOptions: allOptions,
    }));
  };

  const actionAddToCalendar = (selectedOption) => {
    setState((prevState) => ({
      ...prevState,
      selected_calendar_to_take_action: selectedOption,
    }));
  };

  const actionAppointmentMarkAsDoneChange = (selectedOption) => {
    setState((prevState) => ({
      ...prevState,
      selected_appointment_mark_as_to_take_action: selectedOption,
    }));
  };

  const getDefaultOptionForCalendar = () => {
    let allOptions = [];
    if (props.allCalendar.length > 0) {
      allOptions = props.allCalendar.map((data, index) => {
        return {
          value: data.id,
          label: data.title,
        };
      });
    }
    setState((prevState) => ({
      ...prevState,
      defaultCalendarOptions: allOptions,
    }));
  };

  /*For tag*/
  const actionAddToTag = (selectedOption) => {
    setState((prevState) => ({
      ...prevState,
      selected_tag_to_take_action: selectedOption,
    }));
    setTriggerItemValue();
  };

  const getDefaultOptionForTag = (options) => {
    let allOptions = [];
    if (props.allTag.length > 0) {
      const filteredTags =
        hasGlobalFeaturePermission &&
        props.triggerRule.privacy_level &&
        props.triggerRule.privacy_level === PRIVACY_LEVEL.PRIVACY_LEVEL_GLOBAL
          ? props.allTag.filter(
              (item) =>
                item.privacy_level === PRIVACY_LEVEL.PRIVACY_LEVEL_GLOBAL
            )
          : props.allTag;
      allOptions = filteredTags.map((data) => {
        return {
          value: data.id,
          label: data.name,
        };
      });
    }
    setState((prevState) => ({
      ...prevState,
      defaultTagOptions: allOptions,
    }));

    let sideOptions = [];
    sideOptions = options.map((data, index) => {
      return {
        value: index,
        label: data[index],
      };
    });
    setState((prevState) => ({
      ...prevState,
      defaultTagEventOptions: sideOptions,
    }));
  };

  const actionAddToList = (selectedOption) => {
    setState((prevState) => ({
      ...prevState,
      selected_list_to_take_action: selectedOption,
    }));
    setTriggerItemValue();
  };

  const getDefaultOptionForContactList = (options) => {
    let allOptions = [];
    if (props.allList.length > 0) {
      allOptions = props.allList.map((data) => {
        return {
          value: data.id,
          label: data.title,
        };
      });
    }
    setState((prevState) => ({
      ...prevState,
      defaultListOptions: allOptions,
    }));

    let sideOptions = [];
    sideOptions = options.map((data, index) => {
      return {
        value: index,
        label: data[index],
      };
    });
    setState((prevState) => ({
      ...prevState,
      defaultListEventOptions: sideOptions,
    }));
  };

  const actionAddToForm = (selectedOption) => {
    setState((prevState) => ({
      ...prevState,
      selected_form_to_take_action: selectedOption,
    }));
  };

  const getDefaultOptionForFormSubmission = (options) => {
    let allOptions = [];
    if (props.allForm.length > 0) {
      const filteredForm =
        hasGlobalFeaturePermission &&
        props.triggerRule.privacy_level &&
        props.triggerRule.privacy_level === PRIVACY_LEVEL.PRIVACY_LEVEL_GLOBAL
          ? props.allForm.filter(
              (item) =>
                item.privacy_level === PRIVACY_LEVEL.PRIVACY_LEVEL_GLOBAL
            )
          : props.allForm;
      allOptions = filteredForm.map((data) => {
        return {
          value: data.id,
          label: data.title,
          type: data.type,
        };
      });
    }
    setState((prevState) => ({
      ...prevState,
      defaultFormOptions: allOptions,
    }));

    let sideOptions = [];
    sideOptions = options.map((data, index) => {
      return {
        value: index,
        label: data[index],
      };
    });
    setState((prevState) => ({
      ...prevState,
      defaultFormEventOptions: sideOptions,
    }));
  };

  const getDefaultOptionForDeal = (options) => {
    let sideOptions = [];
    sideOptions = options.map((data, index) => {
      return {
        value: index,
        label: data[index],
      };
    });
    setState((prevState) => ({
      ...prevState,
      defaultDealStatusEventOptions: sideOptions,
    }));
  };

  const getDefaultOptionForTaskRemainder = (options) => {
    let sideOptions = [];
    sideOptions = options.map((data, index) => {
      return {
        value: index,
        label: data[index],
      };
    });
    setState((prevState) => ({
      ...prevState,
      defaultTaskRemainderEventOptions: sideOptions,
    }));
  };

  const actionAddToTriggerPipeline = (selectedOption) => {
    setState((prevState) => ({
      ...prevState,
      selected_pipeline_to_take_action: selectedOption,
    }));
    if (
      selectedOption != null &&
      state.selected_pipeline_to_take_action != null &&
      state.selected_pipeline_to_take_action.value != selectedOption.value
    ) {
      setState((prevState) => ({
        ...prevState,
        selected_stage_to_take_action: null,
      }));
    //   setTriggerItemValue();
    }
    getDefaultOptionForStage(
      selectedOption == null ? null : selectedOption.value
    );
  };

  const actionAddToTriggerDealStatus = (selectedOption) => {
    setState((prevState) => ({
      ...prevState,
      deal_pipeline_id: selectedOption,
    }));

    // immediately recalc & dispatch
    setTriggerItemValue();
  };

  const actionAddToStage = (selectedOption) => {
    setState((prevState) => ({
      ...prevState,
      selected_stage_to_take_action: selectedOption,
    }));

    // setTriggerItemValue();
  };

  const getDefaultOptionForPipeline = () => {
    let allOptions = [];
    if (props.allPipeline.length > 0) {
      const filteredPipelines =
        hasGlobalFeaturePermission &&
        props.triggerRule.privacy_level &&
        props.triggerRule.privacy_level === PRIVACY_LEVEL.PRIVACY_LEVEL_GLOBAL
          ? props.allPipeline.filter(
              (item) =>
                item.privacy_level === PRIVACY_LEVEL.PRIVACY_LEVEL_GLOBAL
            )
          : props.allPipeline;
      allOptions = filteredPipelines.map((data, index) => {
        return {
          value: data.id,
          label: data.title,
        };
      });
    }
    setState((prevState) => ({
      ...prevState,
      defaultPipelineOptions: allOptions,
    }));
  };

  const getDefaultOptionForStage = (pipelineId) => {
    let allOptions = [];
    if (props.allStage.length > 0) {
      allOptions = props.allStage
        .filter((data) => {
          return data.pipeline_id == pipelineId;
        })
        .map((item) => {
          return {
            value: item.id,
            label: item.stage,
          };
        });
    }
    setState((prevState) => ({
      ...prevState,
      defaultStageOptions: allOptions,
    }));
  };

  //! incoming call
  const actionAddToTriggerIncomingCall = (selectedOption) => {
    setState((prevState) => ({
      ...prevState,
      selected_virtual_number_to_take_action: selectedOption,
    }));

    setTriggerItemValue();
  };

  const getDefaultOptionForIncomingCall = () => {
    let tempVirtualNumbers = [];
    if (props.allVirtualNumber.length > 0) {
      tempVirtualNumbers = props.allVirtualNumber.map((eachVirtualNumber) => {
        return {
          label: eachVirtualNumber.label,
          value: eachVirtualNumber.id,
        };
      });
    }
    setState((prevState) => ({
      ...prevState,
      defaultVirtualNumbers: tempVirtualNumbers,
    }));
  };

  const setTriggerValue = (triggerValue, triggerItemId) => {
    let eachTriggerRow = [];
    let options = [];
    let subOptions = [];
    triggerValue.map((value, index) => {
      options.push(value.option.toString());
      if (
        triggerItemId == TRIGGER_TYPES.ANNIVERSARY_REMAINDER ||
        triggerItemId == TRIGGER_TYPES.BIRTHDAY_REMAINDER
      ) {
        if (
          value.option == ANNIVERSARY_REMAINDER.HAS_TAG ||
          value.option == ANNIVERSARY_REMAINDER.DOES_NOT_HAS_TAG
        ) {
          let tagString = value.subOption;
          if (tagString != "" || tagString != null) {
            let subOption = [];
            let tagArray = tagString.split(",");
            tagArray.map((singleTag, index) => {
              let tagData = getTriggerById(singleTag, props.allTag);
              if (tagData[0]) {
                subOption.push({
                  label: tagData[0].name,
                  value: tagData[0].id,
                });
              }
            });
            subOptions.push(subOption);
          } else {
            subOptions.push(null);
          }
        } else {
          if (value.subOption != "" && value.subOption != null) {
            subOptions.push(value.subOption.toString());
          } else {
            subOptions.push(value.subOption);
          }
        }
      } else {
        if (value.subOption !== "" && value.subOption != null) {
          subOptions.push(value.subOption.toString());
        } else {
          subOptions.push(value.subOption);
        }
      }
      eachTriggerRow = eachTriggerRow.concat(
        <EachTrigger remover={removeFilter} key={index} RowIndex={index} />
      );
    });
    setState((prevState) => ({
      ...prevState,
      eachTriggerRow: eachTriggerRow,
      trigger_value_selected: options,
      trigger_sub_value: subOptions,
      showFiltering: true,
    }));
    // setTriggerItemValue();
  };

  const setRemainingValueAtFirst = (
    optionValues,
    triggerValue,
    trigger_item_id
  ) => {
    if (optionValues.length > 0) {
      let remainingValueSet = [];
      optionValues.map((option, index) => {
        if (index > 0) {
          let indexValue = optionValues
            .filter((item, optionIndex) => optionIndex < index)
            .map((v) => v.option);
          let remainingValuesToTrigger = triggerValue.filter((value) => {
            if (!indexValue.includes(parseInt(Object.keys(value).toString()))) {
              return value;
            }
          });
          remainingValueSet[index] = remainingValuesToTrigger;
        } else {
          remainingValueSet[index] = triggerValue;
        }
      });
      setState((prevState) => ({
        ...prevState,
        remainingValuesToTrigger: remainingValueSet,
      }));
    }
  };

  const changeValue = (id, trigger) => {
    if (id !== state.selected_trigger_id) {
      const old_trigger_value = state.selected_trigger_id;
      setState((prevState) => ({
        ...prevState,
        triggerValue: null,
      }));

      props.setTriggerItemValue([]);
      props.setTriggerItem(id);
      props.changeDefineFilter(id);
      props.setSelectedTriggerActionId({ id });

      setState((prevState) => ({
        ...prevState,
        selected_trigger_id: id,
        selected_trigger: trigger,
        selected_trigger_item_value_length: 1,
        showFiltering: false,
        showSimpleFilter: false,
        added_campaign_option: null,
        selected_campaign_to_take_action_in_campaign_added: null,
        defaultCampaignOptions: [],

        added_tag_option: null,
        defaultTagEventOptions: [],
        selected_tag_to_take_action: null,
        defaultTagOptions: [],

        task_remainder_option: null,
        defaultTaskRemainderEventOptions: [],
        task_remainder_day: null,

        customer_booked_appointment_option: null,
        defaultCalendarOptions: [],
        selected_calendar_to_take_action: null,

        change_stage_option: null,
        selected_pipeline_to_take_action: null,
        selected_stage_to_take_action: null,
        defaultPipelineOptions: [],
        defaultStageOptions: [],

        eachTriggerRow: [],
        trigger_value_selected: [],
        trigger_sub_value: [],

        remainingValuesToTrigger: [],

        deal_pipeline_id: null,
        deal_status: null,
        defaultDealStatusEventOptions: [],

        added_list_option: null,
        defaultListEventOptions: [],
        defaultListOptions: [],
        selected_list_to_take_action: null,

        added_form_option: null,
        defaultFormEventOptions: [],
        defaultFormOptions: [],
        selected_form_to_take_action: null,

        missed_call_option: null,
        selected_missed_call_filter: null,
      }));

      if (id === TRIGGER_TYPES.ADDED_CAMPAIGN) {
        setState((prevState) => ({
          ...prevState,
          added_campaign_option: 0,
        }));
        getDefaultOptionForCampaign();
      } else if (id === TRIGGER_TYPES.STAGE_CHANGE) {
        setState((prevState) => ({
          ...prevState,
          change_stage_option: 0,
        }));
        getDefaultOptionForPipeline();
      } else if (id === TRIGGER_TYPES.CUSTOMER_BOOKED_APPOINTMENT) {
        setState((prevState) => ({
          ...prevState,
          customer_booked_appointment_option: 0,
        }));
        getDefaultOptionForCalendar();
      } else if (id === TRIGGER_TYPES.ADDED_TAG) {
        getDefaultOptionForTag(JSON.parse(trigger.value));
      } else if (id === TRIGGER_TYPES.FORM_SUBMISSION) {
        /*else if (id === TRIGGER_TYPES.CONTACT_LIST) {
                getDefaultOptionForContactList(JSON.parse(trigger.value));
            }*/
        getDefaultOptionForFormSubmission(JSON.parse(trigger.value));
      } else if (id === TRIGGER_TYPES.DEAL_STATUS_CHANGE) {
        getDefaultOptionForPipeline();
        getDefaultOptionForDeal(JSON.parse(trigger.value));
      } else if (id === TRIGGER_TYPES.TASK_REMAINDER) {
        getDefaultOptionForTaskRemainder(JSON.parse(trigger.value));
      } else if (id === TRIGGER_TYPES.CALENDLY_APPOINTMENT_BOOKED) {
      } else if (
        id === TRIGGER_TYPES.INCOMING_CALL ||
        id === TRIGGER_TYPES.OUTGOING_CALL
      ) {
        setState((prevState) => ({
          ...prevState,
          added_virtual_number_option: 0,
        }));
        getDefaultOptionForIncomingCall();
      } else if (id === TRIGGER_TYPES.MISSED_CALL) {
        setState((prevState) => ({
          ...prevState,
          missed_call_option: 1,
        }));
        getDefaultOptionForIncomingCall();
      } else if (
        id === TRIGGER_TYPES.SMS_ACCOUNT_SUSPENDED ||
        id === TRIGGER_TYPES.TWILIO_MESSAGE_FILTER ||
        id === TRIGGER_TYPES.TWILIO_DAILY_MESSAGE_CAP
      ) {
        setState((prevState) => ({
          ...prevState,
          triggerValue: id,
        }));
      } else {
        // let length = JSON.parse(trigger.value).length;
        // setState({
        //   selected_trigger_item_value_length: length,
        // });
        let length;
        try {
          length = JSON.parse(trigger.value).length;
        } catch (e) {
          length = 0;
        }
        setState((prevState) => ({
          ...prevState,
          selected_trigger_item_value_length: length,
        }));
      }

      if (!state.firstRender) {
        if (id !== old_trigger_value) {
          props.resetTriggerActions(true);
        }
        // if(
        //   (id === TRIGGER_TYPES.SMS_ACCOUNT_SUSPENDED ||
        //   id === TRIGGER_TYPES.TWILIO_MESSAGE_FILTER ||
        //   id === TRIGGER_TYPES.TWILIO_DAILY_MESSAGE_CAP)
        //   &&
        //   (old_trigger_value !== TRIGGER_TYPES.SMS_ACCOUNT_SUSPENDED &&
        //   old_trigger_value !== TRIGGER_TYPES.TWILIO_MESSAGE_FILTER &&
        //   old_trigger_value !== TRIGGER_TYPES.TWILIO_DAILY_MESSAGE_CAP)
        // ){
        //   props.resetTriggerActions(true)
        // }
        // else if(
        //   (old_trigger_value === TRIGGER_TYPES.SMS_ACCOUNT_SUSPENDED ||
        //   old_trigger_value === TRIGGER_TYPES.TWILIO_MESSAGE_FILTER ||
        //   old_trigger_value === TRIGGER_TYPES.TWILIO_DAILY_MESSAGE_CAP)
        //   &&
        //   (id !== TRIGGER_TYPES.SMS_ACCOUNT_SUSPENDED &&
        //   id !== TRIGGER_TYPES.TWILIO_MESSAGE_FILTER &&
        //   id !== TRIGGER_TYPES.TWILIO_DAILY_MESSAGE_CAP)
        // ){
        //   props.resetTriggerActions(true)
        // }
      } else {
        setState((prevState) => ({ ...prevState, firstRender: false }));
      }
    }
    hide();
  };

  const setTriggerItemValue = () => {
    const { selected_trigger_id } = state;

    if (selected_trigger_id === TRIGGER_TYPES.ADDED_CAMPAIGN) {
      if (state.selected_campaign_to_take_action_in_campaign_added !== null) {
        props.setTriggerItemValue({
          option: state.added_campaign_option,
          campaign_id:
            state.selected_campaign_to_take_action_in_campaign_added.value,
        });
      } else {
        props.setTriggerItemValue([]);
      }
    } else if (selected_trigger_id === TRIGGER_TYPES.ADDED_TAG) {
      if (
        state.added_tag_option !== null &&
        state.selected_tag_to_take_action !== null
      ) {
        props.setTriggerItemValue({
          option: state.added_tag_option.value,
          tag_id: state.selected_tag_to_take_action.value,
        });
      } else {
        props.setTriggerItemValue([]);
      }
    } else if (selected_trigger_id === TRIGGER_TYPES.FORM_SUBMISSION) {
      /*else if (selected_trigger_id === TRIGGER_TYPES.CONTACT_LIST) {
            if (state.added_list_option !== null && state.selected_list_to_take_action !== null){
                props.setTriggerItemValue({
                    option: state.added_list_option.value,
                    contact_list_id:state.selected_list_to_take_action.value,
                });
            }else{
                props.setTriggerItemValue([]);
            }
        }*/
      if (state.added_form_option !== null) {
        props.setTriggerItemValue({
          option: state.added_form_option.value,
          form_id:
            state.selected_form_to_take_action !== null
              ? state.selected_form_to_take_action.value
              : "",
          type:
            state.selected_form_to_take_action !== null
              ? state.selected_form_to_take_action.type
                ? state.selected_form_to_take_action.type
                : FORM_TYPE.OLD
              : "",
        });
      } else {
        props.setTriggerItemValue([]);
      }
    } else if (selected_trigger_id === TRIGGER_TYPES.DEAL_STATUS_CHANGE) {
      if (state.deal_status !== null) {
        props.setTriggerItemValue({
          option: state.deal_status.value,
          pipeline_id:
            state.deal_pipeline_id !== null ? state.deal_pipeline_id.value : "",
        });
      } else {
        props.setTriggerItemValue([]);
      }
    } else if (selected_trigger_id === TRIGGER_TYPES.TASK_REMAINDER) {
      if (
        state.task_remainder_option !== null &&
        state.task_remainder_day !== null
      ) {
        props.setTriggerItemValue({
          option: state.task_remainder_option.value,
          number_of_day: state.task_remainder_day,
        });
      } else {
        props.setTriggerItemValue([]);
      }
    } else if (
      selected_trigger_id === TRIGGER_TYPES.CUSTOMER_BOOKED_APPOINTMENT
    ) {
      if (state.customer_booked_appointment_option !== null) {
        props.setTriggerItemValue({
          option: state.customer_booked_appointment_option,
          calendar_id:
            state.selected_calendar_to_take_action === null
              ? ""
              : state.selected_calendar_to_take_action.value,
        });
      } else {
        props.setTriggerItemValue([]);
      }
    } else if (selected_trigger_id === TRIGGER_TYPES.STAGE_CHANGE) {
      if (
        state.selected_pipeline_to_take_action !== null &&
        state.selected_stage_to_take_action
      ) {
        props.setTriggerItemValue({
          option: state.change_stage_option,
          pipeline_id: state.selected_pipeline_to_take_action.value,
          stage_id: state.selected_stage_to_take_action.value,
        });
      } else {
        props.setTriggerItemValue([]);
      }
    } else if (
      selected_trigger_id === TRIGGER_TYPES.CONTACT_REPLIED ||
      selected_trigger_id === TRIGGER_TYPES.ANNIVERSARY_REMAINDER ||
      selected_trigger_id === TRIGGER_TYPES.BIRTHDAY_REMAINDER ||
      selected_trigger_id === TRIGGER_TYPES.STALE_OPPORTUNITY ||
      selected_trigger_id === TRIGGER_TYPES.APPOINTMENT
    ) {
      if (
        state.trigger_value_selected.length > 0 &&
        state.trigger_sub_value.length > 0
      ) {
        props.setTriggerItemValue({
          option: state.trigger_value_selected,
          subOption: state.trigger_sub_value,
        });
      } else {
        props.setTriggerItemValue([]);
      }
    } else if (selected_trigger_id === TRIGGER_TYPES.CREATE_ACTIVITY) {
      if (state.trigger_value_selected.length > 0) {
        props.setTriggerItemValue({
          option: state.trigger_value_selected,
          // subOption:state.trigger_sub_value,
        });
      } else {
        props.setTriggerItemValue([]);
      }
    }

    //! Incoming call
    else if (
      selected_trigger_id === TRIGGER_TYPES.INCOMING_CALL ||
      selected_trigger_id === TRIGGER_TYPES.OUTGOING_CALL
    ) {
      if (state.selected_virtual_number_to_take_action) {
        props.setTriggerItemValue({
          option: state.added_virtual_number_option,
          virtual_number_id: state.selected_virtual_number_to_take_action.value,
        });
      } else {
        props.setTriggerItemValue([]);
      }
    } else if (
      selected_trigger_id === TRIGGER_TYPES.APPOINTMENT_STATUS_CHANGE
    ) {
      if (state.selected_appointment_mark_as_to_take_action !== null) {
        props.setTriggerItemValue({
          option: 0,
          subOption: state.selected_appointment_mark_as_to_take_action.id,
        });
      } else {
        props.setTriggerItemValue([]);
      }
    } else if (selected_trigger_id === TRIGGER_TYPES.MISSED_CALL) {
      if (state.selected_missed_call_filter !== null) {
        let selectedVirtualNumber = null;
        if (state.selected_virtual_number_to_take_action !== null) {
          if (state.selected_virtual_number_to_take_action.value === "-1") {
            selectedVirtualNumber = "-1";
          } else if (
            state.selected_virtual_number_to_take_action.value ===
            VIRTUAL_NUMBER_DEFAULT[0].value
          ) {
            selectedVirtualNumber = VIRTUAL_NUMBER_DEFAULT[0].value;
          } else {
            selectedVirtualNumber =
              state.selected_virtual_number_to_take_action.label;
          }
        }

        props.setTriggerItemValue({
          option: state.missed_call_option,
          subOption: state.selected_missed_call_filter.value,
          virtualNumber: selectedVirtualNumber,
        });
      } else {
        props.setTriggerItemValue([]);
      }
    }
  };

  const onChangeHandle = (e) => {
    setState((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
    // setTriggerItemValue();
  };

  const renderTriggerItemLabel = () => {
    if (JSON.stringify(state?.selected_trigger) !== JSON.stringify({})) {
      return (
        <div className={Styles.labelWrp}>
          <div className={Styles.labelInfo}>
            <span className={Styles.labelTitle}>
              {state?.selected_trigger?.name}
            </span>
            <small className={Styles.labelDescription}>
              {state?.selected_trigger?.description}
            </small>
          </div>
          <span className={Styles.iconWrp}>{iconList.arrow_down}</span>
        </div>
      );
    }
    return (
      <div className={Styles.labelWrp}>
        <span>Select trigger item</span>
        <span className={Styles.iconWrp}>{iconList.arrow_down}</span>
      </div>
    );
  };

  const { allTriggerItem } = props;
  const { selected_trigger_id } = state;
  let showClass = "";

  if (state?.show) {
    showClass = "dropdown-wrapper open";
  } else {
    showClass = "dropdown-wrapper";
  }

  // For filter

  let newFilterRowData = [];
  if (state?.eachTriggerRow?.length > 0) {
    state.eachTriggerRow.map((row, index) => {
      newFilterRowData.push(
        <EachTrigger
          selectedValue={state.trigger_value_selected[index]}
          triggerValues={JSON.parse(state.selected_trigger.value)}
          onValueChange={onValueChange}
          onUnitChange={onUnitChange}
          setSelectedTagOption={setSelectedTagOption}
          allCampaign={props.allCampaign}
          allVirtualNumber={props.allVirtualNumber}
          allPipeline={props.allPipeline}
          allStage={props.allStage}
          allTag={props.allTag}
          allCalendar={props.allCalendar}
          triggerSubValue={state.trigger_sub_value[index]}
          remover={removeFilter}
          triggerType={selected_trigger_id}
          remainingValuesToTrigger={state.remainingValuesToTrigger[index]}
          key={index}
          currentTotalRow={state.eachTriggerRow.length}
          RowIndex={index}
          triggerRule={props.triggerRule}
        />
      );
    });
  }

  let oldVirtualNumber = state?.defaultVirtualNumbers;
  let newVirtualNumber = [
    ...VIRTUAL_NUMBER_DEFAULT,
    ...(oldVirtualNumber || []),
  ];
  // let newVirtualNumber = oldVirtualNumber;

  return (
    <div style={{ width: "100%", padding: 20 }}>
      {props.loading && (
        <div className="col-12 loader-min-height d-flex justify-content-center">
          <div className="align-self-center">
            <div className="text-center">{/* <Loader/> */}</div>
          </div>
        </div>
      )}

      {props.data && (
        <>
          <div
            className=""
            style={{
              textAlign: "center",
              borderBottom: "1px solid #e0e0e0",
              paddingBottom: 20,
            }}
          >
            <Typography variant="h4" className="trigger__action_title">
              Triggers
            </Typography>
            {/* <span className="trigger__action_title">What should trigger this rule?</span> */}
          </div>
          <div className="trigger__item" style={{ padding: 0, marginTop: 24 }}>
            <InputLabel className="trigger__action_title">
              Which event should trigger this automation?
            </InputLabel>
            <FormControl className="customFormControl">
              <CustomMenuPype
                popup={{
                  wrapperClass: Styles.popupWrapper,
                  placement: "left",
                  list: allTriggerItem,
                  renderList: (item, index, clickCallback) => {
                    return (
                      <div
                        className={`${Styles.itemWrp} ${
                          state.selected_trigger_id === item.key_index
                            ? Styles.itemSelected
                            : ""
                        }`}
                        key={index}
                        onClick={clickCallback}
                      >
                        <span className={Styles.itemTitle}>{item.name}</span>
                        <small className={Styles.itemDescription}>
                          {item.description}
                        </small>
                      </div>
                    );
                  },
                  onClick: (item) => changeValue(item.key_index, item),
                  height: "auto",
                  width: "__parent__",
                  listStyle: {
                    justifyContent: "left",
                  },
                }}
                label={{
                  renderCustom: renderTriggerItemLabel(),
                }}
                isDisabled={!hasPermission}
              />
            </FormControl>

            <div className="campaign__filter">
              {/* <CampaignFilter /> */}
              {selected_trigger_id == TRIGGER_TYPES.ADDED_TAG && (
                <div
                  className="campaign__filter_row"
                  style={{ padding: "24px 0px 8px" }}
                >
                  {state.showSimpleFilter && (
                    <>
                      <div className="campaign__filter_col">
                        <InputLabel className="selectLabel">
                          Define Filters
                        </InputLabel>
                        <FormControl className="customFormControl">
                          <DropdownHelper
                            datalist={state.defaultTagEventOptions}
                            noneFieldRequired={true}
                            noneFieldTitle="Select filter"
                            noneFieldDisabled={true}
                            className="trigger__select"
                            mapping={{ title: "label", value: "value" }}
                            menuItemClassName="dropdownhelper-menuitem-class"
                            updateSelectedData={actionToChangeAddedTagOption}
                            selectedValue={state.added_tag_option}
                            inputProps={{ "aria-label": "Without label" }}
                            isDisabled={!hasPermission}
                          />
                        </FormControl>
                      </div>
                      <div className="campaign__filter_col">
                        <InputLabel className="selectLabel">
                          Select a tag
                        </InputLabel>

                        <Autocomplete
                          disableClearable
                          className="trigger__autoComplete"
                          options={state.defaultTagOptions}
                          getOptionLabel={(option) => option.label}
                          onChange={(e, value) => actionAddToTag(value)}
                          value={state.selected_tag_to_take_action}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Select Tag"
                              variant="outlined"
                            />
                          )}
                          disabled={!hasPermission}
                        />
                      </div>
                      <Button
                        disabled={!hasPermission}
                        className={`action__delete topRight`}
                        onClick={() => removeSimpleFilter()}
                      >
                        {iconList.redDeleteIcon}Delete
                      </Button>
                    </>
                  )}
                  {!state.showSimpleFilter && (
                    <div className="align-items-center d-flex justify-content-between w-100">
                      <Button
                        disabled={!hasPermission}
                        onClick={() => addSimpleFilter()}
                        className="trigger__item_btn filter_btn"
                      >
                        {iconList.bluePlusIcon}Add Filter
                      </Button>
                      <p className="align-items-center d-flex mr-3 mt-2 red-text right">
                        <Info className="mr-1" /> Filter required
                      </p>
                    </div>
                  )}
                </div>
              )}
              {selected_trigger_id == TRIGGER_TYPES.ADDED_CAMPAIGN && (
                <div className="campaign__filter_row">
                  {state.showSimpleFilter && (
                    <>
                      <div className="campaign__filter_col">
                        <InputLabel className="selectLabel">
                          Define Filters <span style={{ color: "red" }}>*</span>
                        </InputLabel>
                        <FormControl className="customFormControl">
                          <DropdownHelper
                            datalist={[{ label: "In Campaign", value: 0 }]}
                            className="trigger__select"
                            mapping={{ title: "label", value: "value" }}
                            menuItemClassName="dropdownhelper-menuitem-class"
                            updateSelectedData={
                              actionToChangeAddedCampaignOption
                            }
                            selectedValue={{ label: "In Campaign", value: 0 }}
                            inputProps={{ "aria-label": "Without label" }}
                            isDisabled={!hasPermission}
                          />
                        </FormControl>
                      </div>
                      <div className="campaign__filter_col">
                        <InputLabel className="selectLabel">
                          Select a Campaign
                        </InputLabel>

                        <Autocomplete
                          disableClearable
                          className="trigger__autoComplete"
                          options={state.defaultCampaignOptions}
                          getOptionLabel={(option) => option.label}
                          onChange={(e, value) => actionAddToCampaign(value)}
                          value={
                            state.selected_campaign_to_take_action_in_campaign_added
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Campaign"
                              variant="outlined"
                            />
                          )}
                          disabled={!hasPermission}
                        />
                      </div>
                      <Button
                        disabled={!hasPermission}
                        className={`action__delete topRight`}
                        onClick={() => removeSimpleFilter()}
                      >
                        {iconList.redDeleteIcon}Delete
                      </Button>
                    </>
                  )}

                  {!state.showSimpleFilter && (
                    <Button
                      disabled={!hasPermission}
                      onClick={() => addSimpleFilter()}
                      className="trigger__item_btn filter_btn"
                    >
                      {iconList.bluePlusIcon}Add Filter
                    </Button>
                  )}
                </div>
              )}
              {selected_trigger_id ==
                TRIGGER_TYPES.CUSTOMER_BOOKED_APPOINTMENT && (
                <div
                  className="campaign__filter_row"
                  style={{ padding: "24px 0px 8px" }}
                >
                  {state.showSimpleFilter && (
                    <>
                      <div className="campaign__filter_col">
                        <InputLabel className="selectLabel">
                          Define Filters <span style={{ color: "red" }}>*</span>
                        </InputLabel>
                        <FormControl className="customFormControl">
                          <DropdownHelper
                            datalist={[{ label: "In Calendar", value: 0 }]}
                            className="trigger__select"
                            mapping={{ title: "label", value: "value" }}
                            menuItemClassName="dropdownhelper-menuitem-class"
                            updateSelectedData={
                              actionToChangeAddedCampaignOption
                            }
                            selectedValue={{ label: "In Calendar", value: 0 }}
                            inputProps={{ "aria-label": "Without label" }}
                          />
                        </FormControl>
                      </div>
                      <div className="campaign__filter_col">
                        <InputLabel className="selectLabel">
                          Select Calendar
                        </InputLabel>

                        <Autocomplete
                          disableClearable
                          className="trigger__autoComplete"
                          options={state.defaultCalendarOptions}
                          getOptionLabel={(option) => option.label}
                          onChange={(e, value) => actionAddToCalendar(value)}
                          value={state.selected_calendar_to_take_action}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Calendar"
                              variant="outlined"
                            />
                          )}
                        />
                      </div>
                      <Button
                        disabled={
                          !hasPermission ||
                          (isTriggerPrivate && !isUserTriggerOwner)
                        }
                        className={`action__delete topRight`}
                        onClick={() => removeSimpleFilter()}
                      >
                        {iconList.redDeleteIcon}Delete
                      </Button>
                    </>
                  )}

                  {!state.showSimpleFilter && (
                    <Button
                      disabled={
                        !hasPermission ||
                        (isTriggerPrivate && !isUserTriggerOwner)
                      }
                      onClick={() => addSimpleFilter()}
                      className="trigger__item_btn filter_btn"
                    >
                      {iconList.bluePlusIcon}Add Filter
                    </Button>
                  )}
                </div>
              )}
              {selected_trigger_id == TRIGGER_TYPES.FORM_SUBMISSION && (
                <div
                  className="campaign__filter_row"
                  style={{ padding: "24px 0px 8px" }}
                >
                  {state.showSimpleFilter && (
                    <>
                      <div className="campaign__filter_col">
                        <InputLabel className="selectLabel">
                          Define Filters
                        </InputLabel>
                        <FormControl className="customFormControl">
                          <DropdownHelper
                            datalist={state.defaultFormEventOptions}
                            noneFieldRequired={true}
                            noneFieldTitle="Select filter"
                            noneFieldDisabled={true}
                            className="trigger__select"
                            mapping={{ title: "label", value: "value" }}
                            menuItemClassName="dropdownhelper-menuitem-class"
                            updateSelectedData={actionToChangeAddedFormOption}
                            selectedValue={state.added_form_option}
                            inputProps={{ "aria-label": "Without label" }}
                            isDisabled={!hasPermission}
                          />
                        </FormControl>
                      </div>
                      <div className="campaign__filter_col">
                        <InputLabel className="selectLabel">
                          Select Form
                        </InputLabel>

                        <Autocomplete
                          disableClearable
                          className="trigger__autoComplete"
                          options={state.defaultFormOptions}
                          getOptionLabel={(option) => option.label}
                          onChange={(e, value) => actionAddToForm(value)}
                          value={state.selected_form_to_take_action}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Form"
                              variant="outlined"
                            />
                          )}
                          disabled={!hasPermission}
                        />
                      </div>
                      <Button
                        disabled={!hasPermission}
                        className={`action__delete topRight`}
                        onClick={() => removeSimpleFilter()}
                      >
                        {iconList.redDeleteIcon}Delete
                      </Button>
                    </>
                  )}
                  {!state.showSimpleFilter && (
                    <Button
                      disabled={!hasPermission}
                      onClick={() => addSimpleFilter()}
                      className="trigger__item_btn filter_btn"
                    >
                      {iconList.bluePlusIcon}Add Filter
                    </Button>
                  )}
                </div>
              )}
              {selected_trigger_id == TRIGGER_TYPES.DEAL_STATUS_CHANGE && (
                <div
                  className="campaign__filter_row"
                  style={{ padding: "24px 0px 8px" }}
                >
                  {state.showSimpleFilter && (
                    <>
                      <div className="campaign__filter_col">
                        <InputLabel className="selectLabel">
                          Select a Pipeline
                        </InputLabel>

                        <Autocomplete
                          disableClearable
                          className="trigger__autoComplete"
                          options={state.defaultPipelineOptions}
                          getOptionLabel={(option) => option.label}
                          onChange={(e, value) =>
                            actionAddToTriggerDealStatus(value)
                          }
                          value={state.deal_pipeline_id}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Select Pipeline"
                              variant="outlined"
                            />
                          )}
                          disabled={!hasPermission}
                        />
                      </div>
                      <div className="campaign__filter_col">
                        <InputLabel className="selectLabel">
                          Define Filters
                        </InputLabel>

                        <Autocomplete
                          disableClearable
                          className="trigger__autoComplete"
                          options={state.defaultDealStatusEventOptions}
                          getOptionLabel={(option) => option.label}
                          onChange={(e, value) =>
                            actionToChangeDealStatusOption(value)
                          }
                          value={state.deal_status}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Select Deal"
                              variant="outlined"
                            />
                          )}
                          disabled={!hasPermission}
                        />
                      </div>
                      <Button
                        disabled={!hasPermission}
                        className={`action__delete topRight`}
                        onClick={() => removeSimpleFilter()}
                      >
                        {iconList.redDeleteIcon}Delete
                      </Button>
                    </>
                  )}
                  {!state.showSimpleFilter && (
                    <Button
                      disabled={!hasPermission}
                      onClick={() => addSimpleFilter()}
                      className="trigger__item_btn filter_btn"
                    >
                      {iconList.bluePlusIcon}Add Filter
                    </Button>
                  )}
                </div>
              )}
              {selected_trigger_id == TRIGGER_TYPES.TASK_REMAINDER && (
                <div
                  className="campaign__filter_row"
                  style={{ padding: "24px 0px 8px" }}
                >
                  {state.showSimpleFilter && (
                    <>
                      <div className="campaign__filter_col">
                        <InputLabel className="selectLabel">
                          Define Filters
                        </InputLabel>
                        <FormControl className="customFormControl">
                          <DropdownHelper
                            datalist={state.defaultTaskRemainderEventOptions}
                            noneFieldRequired={true}
                            noneFieldTitle="Select filter"
                            noneFieldDisabled={true}
                            className="trigger__select"
                            mapping={{ title: "label", value: "value" }}
                            menuItemClassName="dropdownhelper-menuitem-class"
                            updateSelectedData={
                              actionToChangeTaskRemainderOption
                            }
                            selectedValue={state.task_remainder_option}
                            inputProps={{ "aria-label": "Without label" }}
                            isDisabled={!hasPermission}
                          />
                        </FormControl>
                      </div>
                      <div className="campaign__filter_col">
                        <InputLabel className="selectLabel">
                          Number of Day
                        </InputLabel>

                        <FormControl className="customFormControl">
                          <TextField
                            disabled={!hasPermission}
                            name="task_remainder_day"
                            variant="outlined"
                            value={state.task_remainder_day}
                            onChange={onChangeHandle}
                            type="number"
                            className="subjectField input_field_with_border"
                            placeholder="Type number of day"
                          />
                        </FormControl>
                      </div>
                      <Button
                        disabled={!hasPermission}
                        className={`action__delete topRight`}
                        onClick={() => removeSimpleFilter()}
                      >
                        {iconList.redDeleteIcon}Delete
                      </Button>
                    </>
                  )}
                  {!state.showSimpleFilter && (
                    <div className="align-items-center d-flex justify-content-between w-100">
                      <Button
                        disabled={!hasPermission}
                        onClick={() => addSimpleFilter()}
                        className="trigger__item_btn filter_btn"
                      >
                        {iconList.bluePlusIcon}Add Filter
                      </Button>
                      <p className="align-items-center d-flex mr-3 mt-2 red-text right">
                        <Info className="mr-1" /> Filter required
                      </p>
                    </div>
                  )}
                </div>
              )}
              {selected_trigger_id == TRIGGER_TYPES.STAGE_CHANGE && (
                <div
                  className="campaign__filter_row"
                  style={{ padding: "24px 0px 8px" }}
                >
                  {state.showSimpleFilter && (
                    <>
                      <div className="campaign__filter_col">
                        <InputLabel className="selectLabel">
                          Define Filters <span style={{ color: "red" }}>*</span>
                        </InputLabel>
                        <FormControl
                          className="customFormControl"
                          style={{ marginTop: "10px" }}
                        >
                          <DropdownHelper
                            datalist={[{ label: "In Pipeline", value: 0 }]}
                            className="trigger__select"
                            mapping={{ title: "label", value: "value" }}
                            menuItemClassName="dropdownhelper-menuitem-class"
                            updateSelectedData={
                              actionToChangeAddedCampaignOption
                            }
                            selectedValue={{ label: "In Pipeline", value: 0 }}
                            inputProps={{ "aria-label": "Without label" }}
                            isDisabled={!hasPermission}
                          />
                        </FormControl>
                      </div>
                      <div className="campaign__filter_col">
                        <InputLabel className="selectLabel">
                          Select Pipeline
                        </InputLabel>

                        <Autocomplete
                          disableClearable
                          className="trigger__autoComplete"
                          options={state.defaultPipelineOptions}
                          getOptionLabel={(option) => option.label}
                          onChange={(e, value) =>
                            actionAddToTriggerPipeline(value)
                          }
                          value={state.selected_pipeline_to_take_action}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Pipeline"
                              variant="outlined"
                            />
                          )}
                          disabled={!hasPermission}
                        />
                      </div>
                      <div className="campaign__filter_col">
                        <InputLabel className="selectLabel">
                          Select Stage
                        </InputLabel>

                        <Autocomplete
                          disableClearable
                          className="trigger__autoComplete"
                          options={state.defaultStageOptions}
                          getOptionLabel={(option) => option.label}
                          onChange={(e, value) => actionAddToStage(value)}
                          value={state.selected_stage_to_take_action}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Stage"
                              variant="outlined"
                            />
                          )}
                          disabled={!hasPermission}
                        />
                      </div>
                      <Button
                        disabled={!hasPermission}
                        className={`action__delete topRight`}
                        onClick={() => removeSimpleFilter()}
                      >
                        {iconList.redDeleteIcon}Delete
                      </Button>
                    </>
                  )}

                  {!state.showSimpleFilter && (
                    <div className="align-items-center d-flex justify-content-between w-100">
                      <Button
                        disabled={!hasPermission}
                        onClick={() => addSimpleFilter()}
                        className="trigger__item_btn filter_btn"
                      >
                        {iconList.bluePlusIcon}Add Filter
                      </Button>
                      <p className="align-items-center d-flex mr-3 mt-2 red-text right">
                        <Info className="mr-1" /> Filter required
                      </p>
                    </div>
                  )}
                </div>
              )}
              {(selected_trigger_id == TRIGGER_TYPES.ANNIVERSARY_REMAINDER ||
                selected_trigger_id == TRIGGER_TYPES.APPOINTMENT ||
                selected_trigger_id == TRIGGER_TYPES.BIRTHDAY_REMAINDER ||
                selected_trigger_id == TRIGGER_TYPES.STALE_OPPORTUNITY) && (
                <div className={"trigger__other_columns"}>
                  {state.showFiltering && (
                    <InputLabel className="selectLabel">
                      Define Filters <span style={{ color: "red" }}>*</span>
                    </InputLabel>
                  )}

                  {newFilterRowData}

                  {state.eachTriggerRow.length <
                    state.selected_trigger_item_value_length && (
                    <>
                      {newFilterRowData.length === 0 && (
                        <p className="align-items-center d-flex mr-3 mt-3 red-text right">
                          <Info className="mr-1" /> Filter required
                        </p>
                      )}
                      <Button
                        disabled={!hasPermission}
                        onClick={() => addNewFilter()}
                        className="trigger__item_btn filter_btn"
                      >
                        {iconList.bluePlusIcon}Add Filter
                      </Button>
                    </>
                  )}
                </div>
              )}

              {selected_trigger_id == TRIGGER_TYPES.CREATE_ACTIVITY && (
                <div className={"trigger__other_columns"}>
                  {state.showFiltering && (
                    <InputLabel className="selectLabel">
                      Define Filters <span style={{ color: "red" }}>*</span>
                    </InputLabel>
                  )}

                  {newFilterRowData}

                  {state.eachTriggerRow.length <
                    state.selected_trigger_item_value_length && (
                    <>
                      <Button
                        disabled={!hasPermission}
                        onClick={() => addNewFilter()}
                        className="trigger__item_btn filter_btn"
                      >
                        {iconList.bluePlusIcon}Add Filter
                      </Button>
                    </>
                  )}
                </div>
              )}
              {selected_trigger_id == TRIGGER_TYPES.CONTACT_REPLIED && (
                <div className={"trigger__other_columns"}>
                  {state.showFiltering && (
                    <InputLabel className="selectLabel">
                      Define Filters <span style={{ color: "red" }}>*</span>
                    </InputLabel>
                  )}

                  {newFilterRowData}

                  {state.eachTriggerRow.length <
                    state.selected_trigger_item_value_length && (
                    <Button
                      disabled={!hasPermission}
                      onClick={() => addNewFilter()}
                      className="trigger__item_btn filter_btn"
                    >
                      {iconList.bluePlusIcon}Add Filter
                    </Button>
                  )}
                </div>
              )}
              {(selected_trigger_id === TRIGGER_TYPES.INCOMING_CALL ||
                selected_trigger_id === TRIGGER_TYPES.OUTGOING_CALL) && (
                <IncomingCallFilter
                  defaultVirtualNumbers={state.defaultVirtualNumbers}
                  showSimpleFilter={state.showSimpleFilter}
                  selectedVirtualNumberToTakeAction={
                    state.selected_virtual_number_to_take_action
                  }
                  addNewFilter={addNewFilter}
                  actionAddToTriggerIncomingCall={
                    actionAddToTriggerIncomingCall
                  }
                  addSimpleFilter={() => addSimpleFilter()}
                  removeSimpleFilter={() => removeSimpleFilter()}
                  hasPermission={hasPermission}
                />
              )}

              {selected_trigger_id ==
                TRIGGER_TYPES.APPOINTMENT_STATUS_CHANGE && (
                <div
                  className="campaign__filter_row"
                  style={{ padding: "24px 0px 8px" }}
                >
                  {state.showSimpleFilter && (
                    <>
                      <div className="campaign__filter_col">
                        <InputLabel className="selectLabel">
                          Define Filters <span style={{ color: "red" }}>*</span>
                        </InputLabel>
                        <FormControl className="customFormControl">
                          <DropdownHelper
                            datalist={[{ label: "Marked As", value: 0 }]}
                            className="trigger__select"
                            mapping={{ title: "label", value: "value" }}
                            menuItemClassName="dropdownhelper-menuitem-class"
                            updateSelectedData={
                              actionToChangeAddedCampaignOption
                            }
                            selectedValue={{ label: "Marked As", value: 0 }}
                            inputProps={{ "aria-label": "Without label" }}
                            isDisabled={!hasPermission}
                          />
                        </FormControl>
                      </div>
                      <div className="campaign__filter_col">
                        <InputLabel className="selectLabel">
                          Select Event
                        </InputLabel>

                        <Autocomplete
                          disableClearable
                          className="trigger__autoComplete"
                          options={[{ id: 0, label: "Done" }]}
                          getOptionLabel={(option) => option.label}
                          disabled={!hasPermission}
                          onChange={(e, value) =>
                            actionAppointmentMarkAsDoneChange(value)
                          }
                          value={
                            state.selected_appointment_mark_as_to_take_action
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Event"
                              variant="outlined"
                            />
                          )}
                        />
                      </div>
                      <Button
                        disabled={!hasPermission}
                        className={`action__delete topRight`}
                        onClick={() => removeSimpleFilter()}
                      >
                        {iconList.redDeleteIcon}Delete
                      </Button>
                    </>
                  )}

                  {!state.showSimpleFilter && (
                    <div className="align-items-center d-flex justify-content-between w-100">
                      <Button
                        disabled={!hasPermission}
                        onClick={() => addSimpleFilter()}
                        className="trigger__item_btn filter_btn"
                      >
                        {iconList.bluePlusIcon}Add Filter
                      </Button>
                      <p className="align-items-center d-flex mr-3 mt-2 red-text right">
                        <Info className="mr-1" /> Filter required
                      </p>
                    </div>
                  )}
                </div>
              )}

              {selected_trigger_id == TRIGGER_TYPES.MISSED_CALL && (
                <div
                  className="campaign__filter_row"
                  style={{ padding: "24px 0px 8px" }}
                >
                  {state.showSimpleFilter && (
                    <>
                      <div className="campaign__filter_col">
                        <InputLabel className="selectLabel">
                          Define Filters <span style={{ color: "red" }}>*</span>
                        </InputLabel>
                        <FormControl className="customFormControl">
                          <Autocomplete
                            disableClearable
                            className="trigger__autoComplete"
                            options={MISSED_CALL_FILTER_OPTIONS}
                            getOptionLabel={(option) => option.label}
                            onChange={(e, value) =>
                              actionChangeMissedCall(value)
                            }
                            value={state.selected_missed_call_filter}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Filter"
                                variant="outlined"
                              />
                            )}
                            disabled={!hasPermission}
                          />
                        </FormControl>
                      </div>
                      <div className="campaign__filter_col">
                        <InputLabel className="selectLabel">
                          Apply To:
                        </InputLabel>

                        <Autocomplete
                          disableClearable
                          className="trigger__autoComplete"
                          options={[...VIRTUAL_NUMBER_ALL, ...newVirtualNumber]}
                          getOptionLabel={(option) => option.label}
                          onChange={(e, value) =>
                            actionAddToTriggerIncomingCall(value)
                          }
                          value={state.selected_virtual_number_to_take_action}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Filter"
                              variant="outlined"
                            />
                          )}
                          disabled={!hasPermission}
                        />
                      </div>
                      <Button
                        disabled={!hasPermission}
                        className={`action__delete topRight`}
                        onClick={() => removeSimpleFilter()}
                      >
                        {iconList.redDeleteIcon}Delete
                      </Button>
                    </>
                  )}
                  {!state.showSimpleFilter && (
                    <div className="align-items-center d-flex justify-content-between w-100">
                      <Button
                        disabled={!hasPermission}
                        onClick={() => addSimpleFilter()}
                        className="trigger__item_btn filter_btn"
                      >
                        {iconList.bluePlusIcon}Add Filter
                      </Button>
                      <p className="align-items-center d-flex mr-3 mt-2 red-text right">
                        <Info className="mr-1" /> Filter required
                      </p>
                    </div>
                  )}
                </div>
              )}
            </div>

            {state.triggerValue != null &&
              (state.triggerValue === TRIGGER_TYPES.TWILIO_MESSAGE_FILTER ||
                state.triggerValue ===
                  TRIGGER_TYPES.TWILIO_DAILY_MESSAGE_CAP) && (
                <div className="twilio_error_code_hints_wrp">
                  <span className="techw_header">
                    {state.triggerValue === TRIGGER_TYPES.TWILIO_MESSAGE_FILTER
                      ? "What is Message filtered?"
                      : "What is the Daily Message Cap Reached"}
                  </span>
                  <div className="techw_body_wrp">
                    {state.triggerValue ===
                      TRIGGER_TYPES.TWILIO_MESSAGE_FILTER && (
                      <>
                        <div className="techw_bw_each_wrp">
                          <span className="techw_bwew_dot"></span>
                          <div className="techw_bwew_message">
                            Your message content was flagged as going against
                            carrier guidelines. Your message was filtered
                            (blocked) by Twilio or by the carrier. This may be
                            done by Twilio for violating Twilio’s 
                            <a
                              href="https://www.twilio.com/legal/messaging-policy"
                              target={"_blank"}
                              rel="noreferrer"
                              alt=""
                            >
                              Messaging Policy
                            </a>
                             or 
                            <a
                              href="https://www.twilio.com/legal/aup"
                              target="_blank"
                              rel="noreferrer"
                              alt=""
                            >
                              Acceptable Use Policy
                            </a>
                            , or by a wireless carrier for violating carrier
                            rules or regulations.
                          </div>
                        </div>

                        <div className="techw_bw_each_wrp">
                          <span className="techw_bwew_dot"></span>
                          <span className="techw_bwew_message">
                            Examples of messaging that would be blocked by
                            Twilio are spam, phishing, and fraud. Twilio’s
                            filtering system is in place to protect mobile
                            subscribers from spam or other forms of malicious or
                            unwanted messages.
                          </span>
                        </div>

                        <div className="techw_bw_each_wrp">
                          <span className="techw_bwew_dot"></span>
                          <span className="techw_bwew_message">
                            Wireless carriers have filtering systems in place as
                            well. These carrier filters are used to block
                            abusive traffic, as well as to enforce rules or
                            regulations about what types of messaging are
                            allowed to that country or mobile network.
                          </span>
                        </div>
                      </>
                    )}
                    {state.triggerValue ===
                      TRIGGER_TYPES.TWILIO_DAILY_MESSAGE_CAP && (
                      <>
                        <div className="techw_bw_each_wrp">
                          <span className="techw_bwew_dot"></span>
                          <span className="techw_bwew_message">
                            Your messages to this particular carrier have
                            exceeded the maximum allowable messages for the day.
                            You have sent the maximum allowable daily messages
                            for your Brand to the carrier.
                          </span>
                        </div>

                        <div className="techw_bw_each_wrp">
                          <span className="techw_bwew_dot"></span>
                          <span className="techw_bwew_message">
                            A possible case is you have sent the maximum amount
                            of messages for the day.
                          </span>
                        </div>

                        <div className="techw_bw_each_wrp">
                          <span className="techw_bwew_dot"></span>
                          <span className="techw_bwew_message">
                            The solution is you must wait till the next calendar
                            day to resume message sending. The day resets at
                            00:00 Pacific Time (US). Pacific time is affected by
                            Daylight Savings Time and Standard Time switches.
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}
          </div>
        </>
      )}
    </div>
  );
};

const TriggerItem = connect(mapStateToProps, mapDispatchToProps)(Trigger);
export default TriggerItem;
